import { urlToProperty } from 'query-string-params'
import qs from 'querystringify'
import omitBy from 'lodash/omitBy'

const getParamObject = (querystring = '') => urlToProperty(querystring)

const getParamObjectWithoutArrays = (queryString = '') => {
  return qs.parse(queryString)
}

const convertParamsObjectIntoString = (params = {}) =>
  Object.keys(params)
    .filter(key => key !== 'page')
    .map(key => `${key}=${params[key]}`)
    .join('&')

const removeFalsy = params => omitBy(params, val => val === 'null' || val === 'undefined')

const getObjectSimply = (queryString = '') => {
  const object = qs.parse(queryString)
  return removeFalsy(object)
}

export default {
  getParamObject,
  getParamObjectWithoutArrays,
  convertParamsObjectIntoString,
  getObjectSimply,
}



// WEBPACK FOOTER //
// ./src/utils/routing/params.js